module.exports = __webpack_public_path__ + "static/media/autzusummer.ff660b53.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/blogsPreselected/autzusummer.jpeg
// module id = 2200
// module chunks = 0